module.exports = __webpack_public_path__ + "img/issuance-step-4.e0d4af68.png";